import styled from "styled-components"

export const Main = styled.div`
  width: 100%;
  margin-top: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
  position: relative;
`

export const Wrapper = styled.div`
  width: 83.3%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 40px;

  @media (max-width: 1149px) {
    width: 82.5%;
    flex-wrap: wrap;
    align-items: flex-start;
    display: grid;
    grid-template-columns: repeat(auto-fit, 320px);
    justify-content: center;
  }

  @media (max-width: 799px) {
    width: 88.88%;
  }
`

export const TitleBox = styled.div`
  width: 83.3%;
  display: flex;
  align-items: center;

  @media (max-width: 1149px) {
    width: 82.5%;
  }

  @media (max-width: 799px) {
    width: 88.88%;
  }

  h3 {
    font-size: 2.3rem;
    font-weight: 700;
    line-height: 3.5rem;
    letter-spacing: 0.06em;
    background: linear-gradient(
      90deg,
      #ce9638 5.35%,
      #eae69c 17.05%,
      #b6872d 114.34%
    );

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`
